import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WizardDemo.html?raw';
import on from 'dojo/on';
import WizardView from '../../../moreCore/UI/Wizard/WizardView';
import "../../../moreCore/UI/Wizard/WizardView";
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import MultiSelectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import "../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox";
import Edit from '../../../moreCore/UI/Edit/Edit';
import "../../../moreCore/UI/Edit/Edit";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";

class WizardDemo extends compose(_WidgetBaseSP) {
    templateString: any = template;

    wizardContainer: HTMLElement;

    step1_Content: HTMLElement;
    step1Container: HTMLElement;
    step2_Content: HTMLElement;
    step2Container: HTMLElement;
    step3_Content: HTMLElement;
    step3Container: HTMLElement;
    step4Container: HTMLElement;

    ms1: MdsLax<InstanceType<typeof SearchSelect>>;
    ms2: MdsLax<InstanceType<typeof MultiSelectBox>>;
    ms3: MdsLax<InstanceType<typeof MultiSelectBox>>;
    s4Edit: MdsLax<InstanceType<typeof Edit>>;

    wizard: MdsLax<InstanceType<typeof WizardView>>;

    private setupWizard(): void {
        let wizard = new WizardView();
        this.wizard = wizard;

        wizard.placeAt(this.wizardContainer);

        wizard.setupNavigation(true,
            "none",
            "none",
        );

        let index = -1;
        let index2 = -1;
        let indexExtraPage = -1;

        // scope, node die eingebunden wird, changeevent (emit), validierungsproperty, summary-Property, Titel)
        index = wizard.addPage(this.ms1, this.step1Container, "change", "isValid", "getValue", "seite 1");
        index2 = wizard.addPage(this, this.step2Container, "page2Changed", "isMs2Valid", "getMs2Summary", "seite 2");

        wizard.addPageRule(index2, {
            neededValidPages: [{
                pageIndex: index,
                ignoreIfHidden: false
            }
            ],
            customValidationFct: null,
            failureActions: ["disable"],
            successActions: ["enable"]

        });

        indexExtraPage = wizard.addPage(this, this.step4Container, "page4Changed", "isPage4Valid", "getMs4Summary", "Extraseite!", null, false);
        wizard.addPageRule(indexExtraPage, {
            customValidationFct: lang.hitch(this, this._checkPage4Visibility),
            failureActions: ["hide", "disable"],
            successActions: ["show", "enable", "switchTo"],
            neededValidPages: [{
                pageIndex: index2,
                ignoreIfHidden: true
            }
            ]
        });

        index = wizard.addPage(this.ms3, this.step3Container, "change", "isValid", "getValue", "seite 3");

        wizard.addPageRule(index, {
            customValidationFct: null,
            neededValidPages: [
                {
                    ignoreIfHidden:false,
                        pageIndex: index2

                },
                {
                    pageIndex: indexExtraPage,
                    ignoreIfHidden: true
                }
            ],
            failureActions: ["disable"],
            successActions: ["enable", "switchTo"]
        });

        //wizard.getValidPages

    }

    private setupSelf() {
        this.ms1.setOptions(["1", "2", "3"], ["eins", "zwei", "drei"], "1");
        this.ms1.setMandatory(true);
        //ms["getSummary"] = lang.hitch(this, this.getSummaryForMS);
        

        this.ms2.setOptions(["a", "b", "c"], ["A", "B", "C"]);
        this.ms2.set("label", "ABC?");
        on(this.ms2, "change", lang.hitch(this, this._onChange_MS2));

        this.ms3.setOptions(["x", "y", "z"], ["A", "B", "C"]);
        this.ms3.setLabel("ABC?");

}
    isMs2Valid: boolean = false;
    getMs2Summary() {
        if (this._checkPage4Visibility()) {
            return "Seite 4 verfügbar.";
        }
        else if (this.ms2.getValue().length >= 2) {

            return "Zusammenfassung:<br>Alles passt";
        } else {
            return "zu wenig ausgewählt";
        }

    }
    private _onChange_MS2(value: Array<string>) {
        //debugger;
        if (value.length >= 2) {
            this.isMs2Valid = true;
        } else {
            this.isMs2Valid = false;
        }

        this.emit("page2Changed");
    }

    private _onChange_EditS4(value: string) {
        debugger;
        
        this.emit("page4Changed");
    }

    private getMs4Summary() {
        //debugger;
        return this.s4Edit.getValue();
    }

    private _checkPage4Visibility(): boolean {
        let values = this.ms2.getValue();
        return values.length >= 3;
    }


    private isPage4Valid() {
        debugger;
        return this.s4Edit.isValid;
    }

    private _onClick_Setup(): void {
        this.setupWizard();
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setupSelf();
    }
}

export default mdsWidget(WizardDemo);